export default {
      id: "i-advantage5-usage",
      viewBox: "0 0 54 41",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantage5",
      toString: function () {
        return this.url;
      }
    }